import zod from 'zod';
import { IntegrationFormSchema } from '../schemas';
import { DefenseUserTypes } from './types';

export const DefenseIntegrationFormSchema = zod
  .object({
    id: zod.number().optional(),

    username: zod.string({ message: 'O nome de usuário é obrigatório.' }),

    password: zod.string({ message: 'O nome de usuário é obrigatório.' }),

    serverIp: zod.string().regex(/^(\d{1,3}\.){3}\d{1,3}$/, {
      message:
        'O endereço IP do servidor Defense deve estar no formato válido (ex: 192.168.0.1).',
    }),

    httpPort: zod
      .number()
      .min(1, { message: 'A porta HTTP deve ser um número positivo.' })
      .max(65535, { message: 'A porta HTTP deve ser menor que 65536.' }),

    mqttPort: zod
      .number()
      .min(1, { message: 'A porta MQTT deve ser um número positivo.' })
      .max(65535, { message: 'A porta MQTT deve ser menor que 65536.' }),

    userType: zod.nativeEnum(DefenseUserTypes, {
      errorMap: () => ({ message: 'Tipo de usuário inválido.' }),
    }),
  })
  .merge(IntegrationFormSchema);
